module.exports = `${require.publicPath}banner-img01.6d74a79e.png`;